import React from "react";
import "./Logo.css";
import { defaultHomeSettings, normalizeHomeSettings } from "../utils/homeContent";
import { RUNTIME_PUBLIC_BASE } from "../utils/runtimeBase";

const API = RUNTIME_PUBLIC_BASE;

function AffiliationSlider({ settings }) {
  const homeSettings = normalizeHomeSettings(settings || defaultHomeSettings);
  const items = homeSettings.affiliations
    .filter((item) => item?.image)
    .map((item) => ({
      ...item,
      src: `${API}/uploads/${item.image}`,
    }));

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="logo-section">
      <h2>{homeSettings.affiliations_section_title}</h2>

      <div className="logo-slider">
        <div className="logo-track">
          {[...items, ...items].map((item, index) => (
            <img key={`${item.image}-${index}`} src={item.src} alt={item.title || "Affiliation logo"} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default AffiliationSlider;



